import { ModuleConfig } from '@/core/module';
import { invoiceRoutes } from './routes';
import { useInvoiceStore } from './stores/invoice-store';

export { useInvoices } from './hooks/useInvoices';
export * from './types';

export const InvoicesModule: ModuleConfig = {
    name: 'invoices',
    routes: invoiceRoutes,
    stores: {
        invoices: useInvoiceStore
    },
    initialize: () => {
        console.log('Invoices module initialized');
    }
};
